export function extractBlocks(section) {
  const { columns } = section;
  const mediaColumnIndex = columns.findIndex(i => i.blocks.findIndex(b => b.block_type === 'media') >= 0);
  // const contentColumnIndex = mediaColumnIndex === 1 ? 0 : 1

  const blockMedia = columns[mediaColumnIndex]?.blocks.find(b => b.block_type === 'media') ?? null;
  // const blockContent = columns[contentColumnIndex]?.blocks ?? []

  const contentColumns = columns.filter((_, index) => index !== mediaColumnIndex);

  const blockContent = contentColumns.reduce((acc, currentColumn) => {
    return [...acc, ...currentColumn.blocks];
  }, []);

  return { blockMedia, blockContent };
}

export function extractBlocksCol_1(section) {
  const { columns } = section;

  const blockContent = columns.reduce((acc, currentColumn) => {
    return [...acc, ...currentColumn.blocks];
  }, []);

  const blockMedia = blockContent.find(b => b.block_type === 'media') ?? null;
  const blockText = blockContent.filter(b => b.block_type === 'body_text' || b.block_type === 'heading');

  return { blockMedia, blockText };
}

function convertToObjectByKey(data) {
  return data.reduce((acc, item) => {
    acc[item.block_type] = item; // Lấy block_type làm key
    return acc;
  }, {});
}

export function extractBlocksForSatelliteGrid(section) {
  const { columns } = section;
  const mediaColumnIndex = columns.findIndex(i => i.blocks.findIndex(b => b.block_type === 'media') >= 0);

  const blockMedia = columns[mediaColumnIndex]?.blocks.find(b => b.block_type === 'media') ?? null;
  // const blockContent = columns[contentColumnIndex]?.blocks ?? []
  const blockHeadingIndex = columns.findIndex(i => i.blocks.findIndex(b => b.block_type === 'heading') >= 0);
  const blockHeading = columns[blockHeadingIndex]?.blocks || [];

  const contentColumns = columns.filter((_, index) => index !== mediaColumnIndex && index !== blockHeadingIndex);

  const blockListItem = contentColumns.map(i => i.blocks);
  function extractListItems(data) {
    return data.flatMap(outerArray =>
      outerArray.flatMap(block => block.list_item_items || block.icon_grid_items || []),
    );
  }

  return {
    blockMedia,
    blockHeading: convertToObjectByKey(blockHeading),
    blockListItem: extractListItems(blockListItem),
  };
}

export function extractPercentage(percentStr) {
  const result = parseInt(percentStr, 10);
  return isNaN(result) ? 0 : result;
}

export function extractHeadingHtml(blockContent, tag = 'h2') {
  const headingFallback = `<${tag}>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  </${tag}>`;
  const content =
    blockContent
      .filter(b => b.block_type === 'heading')
      .map(b => `<${tag}>${b.text}</${tag}>`)
      .join('') || headingFallback;

  return content;
}

export function extractDescriptionHtml(blockContent, tag = 'p') {
  const contentFallback = `<${tag}>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam quis ante. In hac habitasse platea
    dictumst. Aliquam libero ante, dignissim non, gravida eu, sollicitudin nec, quam. Proin feugiat.
    Cras nunc. In ac odio non urna congue feugiat. Sed massa sem, accumsan id, facilisis eget,
    dignissim ultricies, metus. Quisque sit amet velit ac quam hendrerit ornare.
  </${tag}>`;
  const content =
    blockContent
      .filter(b => b.block_type === 'body_text')
      .map(b => `<${tag}>${b.text}</${tag}>`)
      .join('') || contentFallback;

  return content ?? contentFallback;
}

export function extractSurveyHtml(blockContent) {
  return (blockContent.find(b => b.block_type === 'stat_group')?.stat_items || [])
    .map(i => `<p><span>${i.value || ''} </span> ${i.title || ''}</p>`)
    .join('');
}

export function extractSurveyItems(blockContent) {
  return (blockContent.find(b => b.block_type === 'stat_group')?.stat_items || []).map(i => ({
    description: i.title,
    percent: extractPercentage(i.value || '0'),
  }));
}

export function extractSpecTableHtml(blockContent) {
  return (blockContent.find(b => b.block_type === 'spec_table')?.spec_table_items || [])
    .map(b => `<p><span>${b.label}</span><span>${b.value}</span></p>`)
    .join('');
}

export function resolveMediaPosition(suggestionFields) {
  const positionMedia = suggestionFields?.layout?.media_column === 'right' ? 2 : 1;
  return {
    positionMedia,
    contentOrder: positionMedia === 2 ? 1 : 2,
    imageOrder: positionMedia,
  };
}
